import axios from "axios"
import { store } from "redux/store/index";
import { api_url, app_url } from "redux/config.js";

axios.defaults.baseURL = api_url;

// A login token lasts 7 days but the browser keeps the session for ever (redux-persist), so a
// customer coming back after a week hit 401 on every call — which the pages' catch blocks showed
// as "500 Server error!", i.e. session expiry dressed up as a server crash, with nothing telling
// them to just sign in again. This is global (registered on the shared axios instance, so raw
// axios() calls are covered too): a 401 while the store holds a token means the session went
// stale — clear it and take them to the login page. A 401 with no stored token is a real
// credentials failure (e.g. wrong password on signin) and is left to the caller.
axios.interceptors.response.use(
    (res) => res,
    (error) => {
        try {
            const status = error && error.response && error.response.status;
            const hasSession = !!(store.getState().user || {}).token;
            const onAuthPage = window.location.pathname.indexOf('/auth/') === 0;
            if (status === 401 && hasSession && !onAuthPage) {
                store.dispatch({ type: 'POST_LOGOUT' });
                window.location.href = '/auth/login?expired=1';
            }
        } catch (e) { /* never let the guard itself break a response */ }
        return Promise.reject(error);
    }
);

const CallApi = (params, options = { showError: true }) => {
    const state = store.getState()
    const user = state.user
    let newparams = params

    const auth_header = "Bearer " + user.token;
    newparams.headers = { ...params.headers, Authorization: auth_header }
    return new Promise((resolve, reject) => {
        axios(newparams).then((res) => {
            resolve(res.data)
        }).catch((error) => {
            console.log('======  api failed  ======>', newparams)
            reject(error)
        })
    })

}
export {
    CallApi
}